import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-black text-white border-t border-cyan-500/20" data-id="element-18">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-19">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-20">
          <div data-id="element-21">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5AxcgcJ7MjJtSJauijUyxj/Screenshot_2025-10-26_at_1.40.38_PM.png" alt="Western Royal Diesel and Wrap" className="h-16 w-auto mb-4" data-id="element-22" />
            <p className="text-gray-400" data-id="element-23">
              Elizabeth, Colorado's premier destination for diesel performance,
              vehicle wrapping, and tinting services.
            </p>
          </div>
          <div data-id="element-24">
            <h4 className="text-lg font-semibold mb-4 text-cyan-400" data-id="element-25">
              Contact Info
            </h4>
            <div className="space-y-3" data-id="element-26">
              <div className="flex items-start gap-3" data-id="element-27">
                <MapPinIcon size={20} className="text-green-400 mt-1 flex-shrink-0" data-id="element-28" />
                <span className="text-gray-400" data-id="element-29">
                  34675 Gaudraut Ct, Elizabeth, CO 80107
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-30">
                <PhoneIcon size={20} className="text-blue-400 flex-shrink-0" data-id="element-31" />
                <span className="text-gray-400" data-id="element-32">(720) 662-0910</span>
              </div>
              <div className="flex items-center gap-3" data-id="element-33">
                <MailIcon size={20} className="text-cyan-400 flex-shrink-0" data-id="element-34" />
                <span className="text-gray-400" data-id="element-35">
                  westernroyaldiesel@gmail.com
                </span>
              </div>
            </div>
          </div>
          <div data-id="element-36">
            <h4 className="text-lg font-semibold mb-4 text-cyan-400" data-id="element-37">Hours</h4>
            <div className="space-y-2 text-gray-400" data-id="element-38">
              <p data-id="element-39">Monday - Sunday: 7:00 AM - 7:00 PM</p>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400" data-id="element-40">
          <p data-id="element-41">
            &copy; {new Date().getFullYear()} Western Royal Diesel and Wrap. All
            rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}